import { Component, OnInit } from "@angular/core";
import { AlertController, LoadingController } from "@ionic/angular";
import { BTN } from "../../../text_control/text_button";
import { STORAGE } from "../../../constant/storages";
import { _getStorage, _setStorage } from "../../../utils/local-storage";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { errMsg } from "../../../text_control/error-msg";
import { Router } from "@angular/router";

@Component({
  selector: "app-delete-fulltax-detail",
  templateUrl: "./delete-fulltax-detail.component.html",
  styleUrls: ["./delete-fulltax-detail.component.scss"],
})
export class DeleteFulltaxDetailComponent implements OnInit {
  Active = 2;
  dataDelete = [];

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  constructor(
    public router: Router,
    private alertController: AlertController,
    private apiService: ApiserviceService,
    public loadingController: LoadingController
  ) {
    let get_delete_fulltax = _getStorage(STORAGE.DATA_DELETE_FULLTAX);
    this.dataDelete = get_delete_fulltax.invoice_list;
  }

  ngOnInit() {}
  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);

    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
    }
  }
  async deleteFulltax(item) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class-confirm",
      header: "Confirm Delete Fulltax!",
      message: `เลขที่ใบกำกับภาษี/ใบทดแทน/ใบลดหนี้ <br> เลขที่  ${item.tax_invoice_no}  <br> หรือไม่? `,
      buttons: [
        {
          text: "ยกเลิก",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "ตกลง",
          cssClass: "alertloginOk",
          handler: async () => {
            try {
              const req = {
                storeBu: item.bu,
                storeLoc: item.loc,
                userId: this.userID,
                taxInvoiceNo: item.tax_invoice_no,
              };
              console.log("======= req confrim delete ======", req);
              this.apiService
                ._post(
                  this.apiService.apiUrl + this.apiService.confirmDeleteFulltax,
                  req
                )
                .then((res) => {
                  console.log("======= res confrim delete ======", res);
                  if (res.statusCode === 200) {
                    this.ErrorMsg(res.statusMessage);
                  } else {
                    this.ErrorMsg(res.statusMessage);
                  }
                });
            } catch (error) {
              // this.ErrorMsg(errMsg.error)
            }
          },
        },
      ],
    });

    await alert.present();
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  backpage() {
    this.router.navigate(["backoffice/delete-fulltax"]);
  }
}
